import api from '@/services/api';
import apiV2 from '@/services/apiV2';
import { IProduct } from '@/store/ducks/products/types';
import { ProductMenu } from '@/store/ducks/ProductsMenu/type';

export async function getProductsMenuDetails(id: number): Promise<ProductMenu> {
  const response: ProductMenu = await apiV2.get(`webapp/product-catalogs/${id}/info`);
  return response;
}

export async function getProductsmenu(id: number, shopId: number): Promise<IProduct[]> {
  const response: IProduct[] = await api.get(`/products/catalog/${id}`, {
    params: { shop_id: shopId },
  });

  return response;
}
